export const allowOnlyPrice = (e) => {
  e.target.value = e.target.value.replace(/[^0-9]/g, "");
  e.target.value = `₹ ${parseInt(
    e.target.value.replace(",", "") || 0
  ).toLocaleString("en-IN")}`;
};
